import { useContext } from 'react';
import { SchoolGiveWidget } from './SchoolGiveWidget';
import { SearchContext } from './SearchContext';

/**
 * A give widget and (optionally) some project-results for a specific school. Shown when the user specifies a school in
 * search.
 *
 * TODO rename?
 *
 * SLG2TODO If it's easy to do, it'd probably be nicer to not show the give widget until the search finishes loading.
 */
export const SchoolRelatedSection = ({ schoolId, schoolName, projectList }) => {
    const { isMonthlySchoolDonationEnabled } = useContext(SearchContext);
    return (
        <div className="school-give">
            <h3 className="school-name">{schoolName}</h3>
            <SchoolGiveWidget schoolId={schoolId} schoolName={schoolName} key={0} useAjax={false} monthlySchoolDonationEnabled={isMonthlySchoolDonationEnabled} />
            {projectList}
        </div>
    );
};
